


export interface RedatedParams {
	dateFrom: string,
	dateTo: string,
	customerId?: string,
	dc?: string,
	materialId?: string,
	region?: string,
	district?: string,
	filterDate?: string,
}


export enum RedatedTypeEnum {
	outgoing = 'OUTGOING',
	incoming = 'INCOMMING',
}